import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const CarditByReceivingAirlineReport = (props) => {
  if (props.userType === 'I') {
    return (
      <Report
        id={props.id}
        tabs={[
          {
            value: ReportDefinitions.CARDIT_BY_RECEIVING_AIRLINE.id,
            label: 'Overview',
          },
          {
            value: ReportDefinitions.CARDIT_BY_RECEIVING_AIRLINE_NUMBERED.id,
            label: '123',
          },
        ]}
        {...props}
      />
    );
  }
  return (
    <Report
      id={props.id}
      tabs={[
          {
            value: ReportDefinitions.CARDIT_BY_RECEIVING_AIRLINE.id,
            label: 'Overview',
          },
        ]}
      {...props}
    />
  );
};

export default CarditByReceivingAirlineReport;

CarditByReceivingAirlineReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  userType: PropTypes.string,
};
